import { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const CustomerRegistrationRoutes = defineRoute({
    record: {
        route: {
            path: "/customer-registration",
            component: () => loadView(import("./CustomerRegistrationTable.vue")),
        },
        build(filter?: { status?: Enums.RegistrationStatusEnum.Values[] }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/customer-registration?&filter=${encoded}`;
            }

            return "/customer-registration";
        },
    },
    create: {
        route: {
            path: "/customer-registration/create",
            component: () => loadView(import("./CustomerRegistrationCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/customer-registration/:id",
            component: () => loadView(import("./CustomerRegistrationUpdate.vue")),
        },
        build(id: string) {
            return `/customer-registration/${id}`;
        },
    },
});
